export enum ClaimProductTypeEnum {
  BOND = 'BOND',
  FIRE = 'FIRE',
  CONTENT = 'CONTENT',
  CONDOMINIUM = 'CONDOMINIUM',
  LENDER = 'LENDER'
}

export const ClaimProductTypeLabels: Record<ClaimProductTypeEnum, string> = {
  [ClaimProductTypeEnum.BOND]: 'Seguro Fiança',
  [ClaimProductTypeEnum.FIRE]: 'Seguro Incêndio',
  [ClaimProductTypeEnum.CONTENT]: 'Conteúdo',
  [ClaimProductTypeEnum.CONDOMINIUM]: 'Condomínio',
  [ClaimProductTypeEnum.LENDER]: 'Prestamista'
};

export const OTHER_PRODUCT_CLAIM_OPTIONS = [
  ClaimProductTypeEnum.FIRE,
  ClaimProductTypeEnum.CONTENT,
  ClaimProductTypeEnum.CONDOMINIUM,
  ClaimProductTypeEnum.LENDER
] as const;

const shortProductLabels: Record<ClaimProductTypeEnum, string> = {
  [ClaimProductTypeEnum.BOND]: 'Fiança',
  [ClaimProductTypeEnum.FIRE]: 'Incêndio',
  [ClaimProductTypeEnum.CONTENT]: 'Conteúdo',
  [ClaimProductTypeEnum.CONDOMINIUM]: 'Condomínio',
  [ClaimProductTypeEnum.LENDER]: 'Prestamista'
};

export const getClaimProductModalTitle = (productType: ClaimProductTypeEnum): string => {
  return `Abertura de Sinistro de Seguro ${shortProductLabels[productType]}`;
};

export const getClaimProductEditModalTitle = (
  productType: ClaimProductTypeEnum
): string => {
  return `Edição de Sinistro de Seguro ${shortProductLabels[productType]}`;
};
